module.exports = __webpack_public_path__ + "static/ment-39f7ceb155efc10b72330202c33cbd69.png";